import { render, staticRenderFns } from "./BookmakerEdit.vue?vue&type=template&id=bc85967c&scoped=true&"
import script from "./BookmakerEdit.vue?vue&type=script&lang=ts&"
export * from "./BookmakerEdit.vue?vue&type=script&lang=ts&"
import style0 from "./BookmakerEdit.vue?vue&type=style&index=0&id=bc85967c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc85967c",
  null
  
)

export default component.exports